import { HandlerResponse, getRequest } from './api';

export const getAirportListAPI = async (): Promise<any> => {
  return getRequest(`${process.env.REACT_APP_API_ENDPOINT}/airport/list`)
    .then((resp: any) => HandlerResponse(resp));
};
